var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49998 3C6.10215 3 5.72062 3.15804 5.43932 3.43934C5.15801 3.72064 4.99998 4.10218 4.99998 4.5V16.3377C5.46441 16.1174 5.97614 16 6.49998 16H19V3H6.49998ZM21 2C21 1.44772 20.5523 1 20 1H6.49998C5.57172 1 4.68148 1.36875 4.0251 2.02513C3.36873 2.6815 2.99998 3.57174 2.99998 4.5V19.5C2.99998 20.4283 3.36873 21.3185 4.0251 21.9749C4.68148 22.6313 5.57172 23 6.49998 23H20C20.5523 23 21 22.5523 21 22V2ZM19 18H6.49998C6.10215 18 5.72062 18.158 5.43932 18.4393C5.15801 18.7206 4.99998 19.1022 4.99998 19.5C4.99998 19.8978 5.15801 20.2794 5.43932 20.5607C5.72062 20.842 6.10215 21 6.49998 21H19V18Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/book.e66e23d9.svg";
export { ForwardRef as ReactComponent };